import { IconBlad, IconPtaszek } from "../icons/index.js";

/**
 * PP-1: pipeline statusu. Etapy z kolkiem i etykieta, lacznik jako pseudoelement
 * ::after etapu, na telefonie uklad pionowy. Wartosci 1:1 z gotowca pipeline.html.
 *
 * ST-3 / A-7: kolor nigdy nie niesie stanu sam. Kazdy etap ma inny KSZTALT w kolku
 * (ptaszek / kropka / numer / krzyzyk), a dla czytnika doklada slowo stanu.
 */

export type StatusEtapu = "oczekuje" | "w-toku" | "zrobione" | "blad";

/** Atrybut data-status zostaje po angielsku - tak nazywa go CSS gotowca. */
const NA_ATRYBUT: Record<StatusEtapu, string> = {
  oczekuje: "pending",
  "w-toku": "active",
  zrobione: "done",
  blad: "error",
};

const NAZWA_STANU: Record<StatusEtapu, string> = {
  oczekuje: "oczekuje",
  "w-toku": "w toku",
  zrobione: "zrobione",
  blad: "błąd",
};

export interface EtapPipeline {
  etykieta: string;
  status: StatusEtapu;
}

export function Pipeline({
  etapy,
  etykieta = "Etapy przetwarzania",
}: {
  /** PP-3: maks. ~5-6 etapow widocznych naraz. */
  etapy: readonly EtapPipeline[];
  etykieta?: string;
}): React.JSX.Element {
  return (
    <ol className="pipeline" aria-label={etykieta}>
      {etapy.map((etap, i) => (
        <li className="pipeline__step" data-status={NA_ATRYBUT[etap.status]} key={etap.etykieta}>
          <span className="pipeline__circle" aria-hidden="true">
            {etap.status === "zrobione" && <IconPtaszek size={16} />}
            {etap.status === "blad" && <IconBlad size={16} />}
            {etap.status === "w-toku" && <span className="live__dot" />}
            {etap.status === "oczekuje" && i + 1}
          </span>
          <p className="pipeline__label">
            {etap.etykieta}
            <span className="tylko-dla-czytnika">{` - ${NAZWA_STANU[etap.status]}`}</span>
          </p>
        </li>
      ))}
    </ol>
  );
}
